import { LEGACY_COURSE_ID, useCourses } from 'hooks/useCourses';
import { HandHygiene } from 'pages/online-trainings/hand-hygiene';
import { HandHygiene as HandHygieneOld } from 'pages/online-trainings-old/hand-hygiene';
import { useParams } from 'react-router-dom';

export const SmartCourseHome = () => {
    const { coursePath } = useParams<{ coursePath: string }>();
    const { allCoursesData, isLoadingCourses } = useCourses();

    if (isLoadingCourses) return null;

    const course = allCoursesData.find((c) => c.path === coursePath);

    if (course?.id === LEGACY_COURSE_ID) {
        return <HandHygieneOld />;
    }

    return <HandHygiene />;
};
